import { api } from "../../../api";
import { toast } from "react-toastify";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const route = api(root);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

const PayrollService = {
  async getPayrollData({ search, startDate, endDate }) {
    try {
      let { data } = await route.get(
        `/Payroll/PayrollPaymentDashboard?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      // console.log({ getPayrollData: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },

  async schedulePayroll(payload) {
    try {
      let { data } = await route.post(
        "/Payroll/SchedulePayrollRunController",
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      console.log({ payload });

      console.log({ schedulePayroll: data });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },
  async initiatePayroll(batchID) {
    try {
      let { data } = await route.post(
        "/Payroll/InitiatePayrollRun",
        { batchId: batchID },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      // console.log({ initiatePayroll: data });

      return data;
    } catch (err) {
      console.log(err);
    }
  },
  async generateAllPayroll(batchID) {
    try {
      let { data } = await route.post(
        "/Payroll/GenerateAllPayroll",
        { batchId: batchID },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      return data;
    } catch (err) {
      console.log(err);
    }
  }, 
  async removestafffrompayroll({ ...value }) {
    try {
      let { data } = await route.post(
        "payroll/removestafffrompayroll",
        { ...value },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      return data;
    } catch (err) {
      console.log(err);
    }
  },
  async approvePayroll({ ...values }) {
    try {
      let { data } = await route.post(
        "/payroll/approvedeclinepayrollrun",
        { ...values },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      return data;
    } catch (err) {
      console.log({ err });
    }
  },
  async removeStaff({ staffID, batchID }) {
    try {
      let { data } = await route.post(
        `Payroll/RemoveStaffFromPayroll`,
        { staffID, batchID },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      console.log({ removeStaff: data });
      return data;
    } catch (e) {
      console.log(e);
    }
  },
  async getPayrollStaff({ search, batchID }) {
    try {
      let { data } = await route.get(
        `/Payroll/PayrollViewEmployees?Search=${search}&BatchId=${batchID}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (err) {
      console.log(err);
    }
  },
  async getStaffComponent({
    currentEmployeeID,
    batchID,
    pageSize,
    pageNumber,
  }) {
    try {
      let { data } = await route.get(
        `/Payroll/PayrollViewAllComponent?BatchId=${batchID}&EmployeeId=${currentEmployeeID}&PageSize=${pageSize}&PageNumber=${pageNumber}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      // console.log({ getStaffComponent: data });
      return data;
    } catch (err) {
      console.log(err);
    }
  },
};

export default PayrollService;
